module.exports = __webpack_public_path__ + "img/Butterfly_00120.b80cd71a.png";